export default "__VITE_ASSET__DYMtOrWY__"